<template>
  <div class="d-flex">
    <v-slide-x-transition>
      <div v-show="show && !open" @click="openContact" class="contact">
        <div class="logo"></div>
        <div class="text d-flex jc-center ai-center p-relative">
          {{ $t("nav.contact") }}
        </div>
      </div>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <div v-show="show && open" class="contact-dialog">
        <div class="w-100 d-flex ai-center contact-header">
          <span class="ml-4">
            <v-btn @click="setOpen(false)" icon>
              <v-icon large color="#fff">mdi-chevron-left</v-icon>
            </v-btn>
          </span>
          <div class="d-flex flex-1 jc-center">
            <span class="text-white fw-weight mr-2">
              {{ $t("nav.contact") }}
            </span>
          </div>
        </div>
        <div class="py-4 d-flex flex-column flex-1 overflow-y-overlay">
          <div
            class="d-flex flex-column-reverse w-100 overflow-y-overlay p-relative"
            style="font-size: 0.85rem;"
          >
            <div
              v-for="(msg, idx) in messages"
              :key="'msgs' + idx"
              class="d-flex mb-5"
              :class="{ 'jc-end': !msg.managerId }"
            >
              <div
                class="d-flex w-100"
                :class="{ 'jc-end flex-row-reverse': !msg.managerId }"
              >
                <div class="d-flex avatar mx-4">
                  <img v-if="!msg.managerId" :src="avatar" alt="user_avatar" />
                  <img
                    v-else
                    src="/assets/ic/contact/chatbox_head.svg"
                    alt="admin_avatar"
                  />
                </div>
                <div class="d-flex flex-column flex-1">
                  <div class="d-flex" :class="{ 'jc-end': !msg.managerId }">
                    <span class="messagebox pa-4 pre-line">
                      {{ msg.content }}
                    </span>
                  </div>
                  <div class="d-flex" :class="{ 'jc-end': !msg.managerId }">
                    <span class="mx-2 text-gray-2" style="font-size: 1rem;">
                      {{ dateFormat(msg.createTime) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="loading || hasMessages"
              class="d-flex w-100 ai-center jc-center"
              style="min-height: 3.5rem"
              key="messageLoadingKey"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <div
              v-show="hasMessages && !loading && initialed"
              v-intersect="infiniteScrolling"
              key="infiniteScrolling"
            >
              zzz
            </div>
          </div>
        </div>
        <div class="d-flex jc-between w-100 contact-submit pa-4">
          <textarea
            class="contact-textarea flex-1 pa-2 mr-4"
            v-model="reply"
            @keydown.enter.exact="sendMessage"
          ></textarea>
          <v-btn
            class="btn-rounded"
            color="orange"
            depressed
            min-width="8rem"
            min-height="2.5rem"
            @click="sendMessage"
            dark
          >
            {{ $t("submit") }}
          </v-btn>
        </div>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { sendWS } from "@/plugins/websocket";
async function sleep(ms = 0) {
  return new Promise(r => setTimeout(r, ms));
}
export default {
  data() {
    return {
      reply: ""
    };
  },
  computed: {
    ...mapState("contact", [
      "show",
      "open",
      "messages",
      "loading",
      "hasMessages",
      "initialed"
    ]),
    ...mapState("user", ["avatar"])
  },
  methods: {
    ...mapMutations("contact", ["setOpen", "setLoading"]),
    ...mapActions("contact", ["openContact"]),
    async sendMessage() {
      console.log(this.reply);
      const data = {
        Event: "sendMessage",
        Content: this.reply
      };
      sendWS(data);
      await sleep(50);
      this.reply = "";
    },
    async infiniteScrolling() {
      if (this.loading || !this.hasMessages) return;
      console.log(this.hasMessages);
      this.setLoading(true);
      const data = {
        Event: "scrollMessage",
        Content: this.messages[this.messages.length - 1].messageId
      };
      sendWS(data);
    }
  }
};
</script>

<style lang="sass" scoped>

.btn-rounded
  border-radius: 0.5rem

.avatar
  width: 2.5rem
  height: 2.5rem
  border-radius: 100%
  background: #F6F6F6
  overflow: hidden
  > img
    object-fit: contain
    flex: 1
    height: 100%


.contact-textarea
  border-radius: 0.5rem
  border: 2px solid #dcdcdc
  font-size: 0.85rem

.messagebox
  border: 0.1rem solid #EAEAEA
  border-radius: 0.5rem
  max-width: 15rem

.pre-line
  white-space: pre-line

.contact-dialog
  position: fixed
  z-index: 20
  display: flex
  flex-direction: column
  left: 0
  bottom: 0
  width: 28rem
  height: 32.5rem
  background: white
  box-shadow: 10px 10px 20px 0 #969696
  .contact-header
    height: 3rem
    background: #e40029
  .contact-submit
    height: 6rem
    border-top: 1px solid #979797


.contact
  cursor: pointer
  position: fixed
  z-index: 20
  display: flex
  height: 6.5rem
  width: 22.5rem
  left: 0
  top: 70vh
  &.hide
    display: none !important
  .logo
    width: 12rem
    background-color: white
    box-shadow: 3px 3px 8px 0px #d2d2d2a1
    background-image: url("/assets/bg/contact_logo.png")
    background-position: center
  .text
    width: 10.5rem
    color: white
    background: #e40029
    border-radius: 0 100% 100% 0
    //box-shadow: 3px 3px 8px 0px #d2d2d2a1
    &:after
      z-index: -1
      position: absolute
      content: " "
      background: #e40029
      left: 0
      width: 4rem
      height: 6.5rem
      box-shadow: 3px 3px 8px 0px #d2d2d2a1
    &:before
      z-index: -1
      position: absolute
      content: " "
      background: #e40029
      width: 6.5rem
      height: 6.5rem
      right: 0
      border-radius:0 100% 100% 0
      box-shadow: 3px 3px 8px 0px #d2d2d2a1
</style>
